import React, { useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { getEmployeesWorkSchedule } from "../../../core/data/redux/employeesWorkScheduleSlice";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { useState } from "react";
import { year } from '../../../core/common/selectoption/selectoption';


interface EmployeeWorkScheduleProps {
    employee?: any;
}

const EmployeeWorkSchedule: React.FC<EmployeeWorkScheduleProps> = ({ employee }) => {
    const routes = all_routes;
    const dispatch = useDispatch();
    const location = useLocation();
    const stateEmployee = location.state?.employee;
    const resolvedEmployee = employee || stateEmployee;
    const empId = resolvedEmployee?.empId;

    
    const employeesWorkScheduleState = useSelector(
        (state: any) => state.employeesWorkScheduleState
    );
    const [events, setEvents] = useState<any[]>([]);



    const calendarRef = useRef<any>(null);

    const currentDate = new Date();
    const [selectedMonth, setSelectedMonth] = useState(currentDate.getMonth());
    const [selectedYear, setSelectedYear] = useState(currentDate.getFullYear());

    const handleDateChange = (month: number, year: number) => {
        setSelectedMonth(month);
        setSelectedYear(year);
        const calendarApi = calendarRef.current.getApi();
        calendarApi.gotoDate(new Date(year, month, 1)); // navigate calendar
    };

    const years = Array.from({ length: 20 }, (_, i) => currentDate.getFullYear() - 10 + i);
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];


    useEffect(() => {
        if (employeesWorkScheduleState.loading === "fulfilled" && employeesWorkScheduleState.action === "list") {
            const data = employeesWorkScheduleState?.data?.data || [];
            const scheduleRules = data?.master_work_schedules_details?.schedule_rules || [];


            const now = new Date();
            const baseMonth = `${selectedYear}-${String(selectedMonth + 1).padStart(2, '0')}`;


           

            const eventsList = scheduleRules.map((item: any) => {
                const isWork = item.code === "DFDW";
                return {
                    title: item.value,
                    className: isWork ? 'badge badge-green-transparent' : 'badge badge-pink-transparent',
                    backgroundColor: isWork ? '#E5FFF1' : '#FFEDF6',
                    textColor: isWork ? '#00B96B' : '#FD3995',
                    start: `${baseMonth}-${item.day.padStart(2, '0')}`,
                    end: `${baseMonth}-${item.day.padStart(2, '0')}`,
                };
            });
            console.log("Events List:", eventsList);
            setEvents(eventsList);
        }
    }, [employeesWorkScheduleState.loading]);

    const fetchRecords = () => {
        dispatch(
            getEmployeesWorkSchedule({
                empId: empId,
                month: selectedMonth,
                year: selectedYear
            })
        );
    };

    useEffect(() => {
        fetchRecords();
    }, [empId, selectedMonth, selectedYear]);



    return (
        <div>
            <div className="page-wrapper">
                <div className="content">
                    <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                        <div className="my-auto mb-2">
                            <h3 className="page-title mb-1">Work Schedule</h3>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={routes.adminDashboard}>Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="#">Team</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Work Schedule
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">

                            <div style={{ marginBottom: 10, display: "flex", gap: "10px" }}>
                                <select
                                    value={selectedMonth}
                                    onChange={(e) => handleDateChange(parseInt(e.target.value), selectedYear)}
                                >
                                    {months.map((m, idx) => (
                                        <option key={idx} value={idx}>
                                            {m}
                                        </option>
                                    ))}
                                </select>

                                <select
                                    value={selectedYear}
                                    onChange={(e) => handleDateChange(selectedMonth, parseInt(e.target.value))}
                                >
                                    {years.map((y) => (
                                        <option key={y} value={y}>
                                            {y}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="card border-0">
                                <div className="card-body">
                                    <FullCalendar
                                        plugins={[
                                            dayGridPlugin,
                                            timeGridPlugin,
                                            interactionPlugin,
                                        ]}
                                        initialView="dayGridMonth"
                                        events={events}
                                        headerToolbar={{
                                            start: "",
                                            center: "title",
                                            end: "",
                                        }}
                                        //eventClick={handleEventClick}
                                        ref={calendarRef}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default EmployeeWorkSchedule;